'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
Entry.ThreadView = /*#__PURE__*/function () {
  function ThreadView(thread, board) {
    (0, _classCallCheck2["default"])(this, ThreadView);
    (0, _defineProperty2["default"])(this, "schema", {
      height: 0,
      zIndex: 0
    });
    Entry.Model(this, false);
    this.thread = thread;
    this.svgGroup = board.svgThreadGroup.elem('g');
    this.board = board;
    this.parent = board; // statement

    this._hasGuide = false;
  }
  return (0, _createClass2["default"])(ThreadView, [{
    key: "destroy",
    value: function destroy() {
      this.svgGroup.remove();
    }
  }, {
    key: "setParent",
    value: function setParent(parent) {
      this.parent = parent;
    }
  }, {
    key: "getParent",
    value: function getParent() {
      return this.parent;
    }
  }, {
    key: "renderText",
    value: function renderText() {
      var blocks = this.thread.getBlocks();
      for (var i = 0; i < blocks.length; i++) {
        blocks[i].view.renderText();
      }
    }
  }, {
    key: "renderBlock",
    value: function renderBlock() {
      var blocks = this.thread.getBlocks();
      for (var i = 0; i < blocks.length; i++) {
        blocks[i].view.renderBlock();
      }
    }
  }, {
    key: "requestAbsoluteCoordinate",
    value: function requestAbsoluteCoordinate(blockView) {
      var board = this.board;
      var _ref = board || {},
        _ref$scale = _ref.scale,
        scale = _ref$scale === void 0 ? 1 : _ref$scale;
      var blocks = this.thread.getBlocks();
      var block = blocks.shift();
      var pos = {
        x: 0,
        y: 0
      };
      var parent = this.parent;
      if (!(parent instanceof Entry.Board || parent instanceof Entry.BlockMenu) && parent.requestAbsoluteCoordinate) {
        pos = parent.requestAbsoluteCoordinate();
      }
      while (block && block.view !== blockView && block.view) {
        var prevBlockView = block.view;
        pos.x += prevBlockView.x + prevBlockView.magnet.next.x * scale;
        pos.y += prevBlockView.y + prevBlockView.magnet.next.y * scale;
        block = blocks.shift();
      }
      return pos;
    }
  }, {
    key: "requestPartHeight",
    value: function requestPartHeight(blockView) {
      var blocks = this.thread.getBlocks();
      var block = blocks.pop();
      var height = 0;
      if (blockView) {
        height = blockView.magnet.next ? blockView.magnet.next.y : blockView.height;
      }
      while (block && block.view !== blockView && block.view) {
        var prevBlockView = block.view;
        if (prevBlockView.magnet.next) {
          height += prevBlockView.magnet.next.y;
        } else {
          height += prevBlockView.height;
        }
        if (prevBlockView.dragMode === Entry.DRAG_MODE_DRAG) {
          height = 0;
        }
        block = blocks.pop();
      }
      return height;
    }
  }, {
    key: "getMagnet",
    value: function getMagnet() {
      return {
        getBoundingClientRect: function () {
          var halfWidth = 20;
          var coord = this.parent.requestAbsoluteCoordinate();
          var boardOffset = this.board.relativeOffset;
          return {
            top: coord.y + boardOffset.top - halfWidth,
            left: coord.x + boardOffset.left - halfWidth,
            width: 2 * halfWidth,
            height: 2 * halfWidth
          };
        }.bind(this)
      };
    }
  }, {
    key: "dominate",
    value: function dominate() {
      !this._hasGuide && this.parent.dominate(this.thread);
    }
  }, {
    key: "isGlobal",
    value: function isGlobal() {
      return this.parent instanceof Entry.Board;
    }
  }, {
    key: "reDraw",
    value: function reDraw() {
      var blocks = this.thread._data;
      for (var i = blocks.length - 1; i >= 0; i--) {
        var b = blocks[i];
        if (b.view) {
          b.view.reDraw();
        } else {
          b.createView(this.thread._code.view.board);
        }
      }
    }
  }, {
    key: "setZIndex",
    value: function setZIndex(zIndex) {
      this.set({
        zIndex: zIndex
      });
    }
  }, {
    key: "setHasGuide",
    value: function setHasGuide(bool) {
      this._hasGuide = bool;
    }
  }, {
    key: "getFields",
    value: function getFields() {
      var BLOCK = Entry.Block;
      return this.thread.getBlocks().reduce(function (fields, block) {
        if (!(block instanceof BLOCK)) {
          return fields;
        }
        return fields.concat(block.view.getFields());
      }, []);
    }
  }]);
}();